import { ChangeEvent, KeyboardEvent, ReactNode } from 'react';

interface TitleFieldProps {
    heading: string;
    description: ReactNode;
    value: string;
    onChange: (e: ChangeEvent<HTMLInputElement>) => void;
    onKeyDown: (e: KeyboardEvent<HTMLInputElement>) => void;
    formSubmitted: boolean;
    disabled: boolean;
    baseInputClass: string;
    counterClassName: string;
}

export const TitleField = ({
    heading,
    description,
    value,
    onChange,
    onKeyDown,
    formSubmitted,
    disabled,
    baseInputClass,
    counterClassName
}: TitleFieldProps) => (
    <>
        <h4 className={`text-lg font-semibold ${disabled ? 'text-gray-500' : 'text-jtc-very-dark-grey'}`}>
            {heading}
        </h4>
        <p className={`text-sm mb-4 break-words ${disabled ? 'text-gray-400' : 'text-gray-500'}`}>
            {description}
        </p>
        <input
            type="text"
            id="assistantTitle"
            className={`${baseInputClass} ${formSubmitted && !value
                ? 'border-jtc-pink focus:border-jtc-pink'
                : 'border-jtc-grey focus:border-jtc-blue focus:ring-1 focus:ring-jtc-blue focus:outline-none'
                }`}
            placeholder={formSubmitted && !value ? 'A title is required...' : 'Enter assistant title here...'}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            maxLength={25}
        />
        <div className={counterClassName}>
            {value.length} / 25
        </div>
    </>
);
